var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.87534 10.3113L1.0309 13.9557C1.00177 14.089 1.00277 14.227 1.03382 14.3598C1.06488 14.4926 1.1252 14.6168 1.21039 14.7232C1.29558 14.8297 1.40349 14.9158 1.52622 14.9753C1.64895 15.0347 1.78342 15.066 1.91979 15.0668C1.98333 15.0733 2.04736 15.0733 2.1109 15.0668L5.77756 14.2224L12.8176 7.20906L8.88868 3.28906L1.87534 10.3113Z",
    fill: "#90734F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0311 3.69766L12.4089 1.07543C12.2365 0.903907 12.0032 0.807617 11.76 0.807617C11.5168 0.807617 11.2835 0.903907 11.1111 1.07543L9.65332 2.53321L13.5778 6.45766L15.0355 4.99988C15.1209 4.91414 15.1884 4.81241 15.2344 4.70053C15.2803 4.58865 15.3038 4.4688 15.3034 4.34785C15.3029 4.22689 15.2787 4.10721 15.232 3.99564C15.1853 3.88407 15.117 3.78281 15.0311 3.69766Z",
    fill: "#90734F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f67908277505d5d3b305674648ea656b.svg";
export { ForwardRef as ReactComponent };